import { TemplateEnumsRoute } from '../../../constants/api-endpoints';
import { Channel } from '../../../entities/channel';
import { useQuery } from 'react-query';
import * as RestApi from 'core/network/RestApi';
import { generatePath } from 'react-router';

export const useGetChannels = () => {
  return useQuery(['channels'], async () => {
    const result = await RestApi.get<Channel>(generatePath(TemplateEnumsRoute.CHANNELS));
    return result.data;
  });
};
